import { render, staticRenderFns } from "./PlatformGroup.vue?vue&type=template&id=561f8815&scoped=true&"
import script from "./PlatformGroup.vue?vue&type=script&lang=js&"
export * from "./PlatformGroup.vue?vue&type=script&lang=js&"
import style0 from "./PlatformGroup.vue?vue&type=style&index=0&id=561f8815&scoped=true&lang=css&"
import style1 from "./PlatformGroup.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561f8815",
  null
  
)

export default component.exports